import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/feature/sections/HeroSection';
import TrustBar from '../../components/feature/sections/TrustBar';
import AIAnswerBlock from '../../components/feature/sections/AIAnswerBlock';
import ProcessSection from '../../components/feature/sections/ProcessSection';
import WhyChooseUs from '../../components/feature/sections/WhyChooseUs';
import ServiceAreas from '../../components/feature/sections/ServiceAreas';
import Testimonials from '../../components/feature/sections/Testimonials';
import FAQSection from '../../components/feature/sections/FAQSection';
import FinalCTA from '../../components/feature/sections/FinalCTA';
import ServicesOverview from './components/ServicesOverview';

const processSteps = [
  {
    number: '01',
    icon: 'ri-phone-line',
    title: 'Free Consultation',
    description: 'Call or submit a quote request. We assess your property, security needs, and budget — no obligation, no pressure.',
  },
  {
    number: '02',
    icon: 'ri-draft-line',
    title: 'Custom System Design',
    description: 'Our specialists design a tailored security system plan with camera placement, coverage maps, and equipment specs.',
  },
  {
    number: '03',
    icon: 'ri-tools-fill',
    title: 'Professional Installation',
    description: 'Licensed technicians install and configure your entire system with clean wiring and minimal disruption to your property.',
  },
  {
    number: '04',
    icon: 'ri-graduation-cap-line',
    title: 'Training & Support',
    description: 'We walk you through your new system, set up remote monitoring apps, and stay available 24/7 for ongoing support.',
  },
];

const faqs = [
  {
    question: 'Who installs security cameras near me?',
    answer: 'Secure2Ware provides professional security camera installation for homes and businesses across the United States. Our licensed technicians offer same-day and next-day service in most areas, handling everything from single doorbell cameras to full multi-camera commercial surveillance systems with remote monitoring.',
  },
  {
    question: 'How much does a surveillance system cost?',
    answer: 'A basic home security camera system typically starts around $500–$1,500 installed, while commercial systems range from $1,500 to $10,000+ depending on camera count and features. Secure2Ware provides free, no-obligation quotes with transparent flat pricing — no hidden fees or surprise charges.',
  },
  {
    question: 'How long does security system installation take?',
    answer: 'Most residential installations are completed in 4–8 hours in a single day. Commercial systems typically take 1–3 days depending on size and complexity. Our technicians work efficiently to minimize disruption, and all systems are fully tested and demonstrated before we leave your property.',
  },
  {
    question: 'What types of security systems does Secure2Ware install?',
    answer: 'We install security cameras (wired and wireless), CCTV surveillance systems, alarm systems, access control (keypad and fob entry), doorbell cameras, smart home automation, and integrated multi-system setups. We serve both residential and commercial properties of all sizes.',
  },
  {
    question: 'Do you offer monitoring services after installation?',
    answer: 'Yes. We offer optional 24/7 professional monitoring plans where our team watches your cameras and responds to alarms in real time. We also configure remote access so you can monitor your own system from any smartphone, tablet, or computer, anywhere in the world.',
  },
  {
    question: 'Are your security system installers licensed and insured?',
    answer: 'Absolutely. All Secure2Ware technicians are licensed, background-checked, and fully insured. We carry liability insurance and workers\' compensation on every job. Every installation comes with a 10-year warranty on workmanship and manufacturer warranty support on all equipment.',
  },
];

export default function Home() {
  return (
    <main className="bg-white font-sans">
      <Header />
      <HeroSection
        badge="Licensed Security System Installers"
        headline="Professional Security Camera &"
        headlineAccent="Surveillance Installation"
        headlineSuffix="for Homes & Businesses"
        subtitle="Expert installation of security cameras, CCTV systems, alarm systems, access control, and smart automation. Licensed, insured, and trusted by 500+ properties nationwide."
        primaryCTA={{ text: 'Get Free Security Quote', href: '#contact' }}
        secondaryCTA={{ text: 'Call (800) 555-1234', href: 'tel:+18005551234' }}
        trustIndicators={['Licensed & Insured', '10-Year Warranty', 'Same-Day Service Available']}
        imageSrc="https://public.readdy.ai/ai/img_res/ab026cbf9f0922846d93e6e2233571cf.jpg"
      />
      <TrustBar />
      <ServicesOverview />
      <AIAnswerBlock
        question="What does Secure2Ware do?"
        answer="Secure2Ware installs and configures security cameras, CCTV surveillance systems, alarm systems, access control, and smart automation solutions for homes and businesses. Services include free system design, professional installation by licensed technicians, remote monitoring setup, and 24/7 ongoing support — all backed by a 10-year warranty."
        highlights={['security cameras', 'CCTV surveillance systems', 'alarm systems', 'access control', 'smart automation']}
      />
      <ProcessSection steps={processSteps} />
      <WhyChooseUs />
      <ServiceAreas />
      <Testimonials />
      <FAQSection items={faqs} />
      <FinalCTA />
      <Footer />
    </main>
  );
}
